import { AreaMap } from '../../domain/area-map';
import { Process } from '../../domain/process';
import { ProcessCalculation } from '../../domain/process-calculation';
import { ProcessMeasure } from '../../domain/process-mesure';
import { mapper } from '../../tools/mapping/mapper';
import { ProcessEntity, ProcessMeasureEntity } from '../entity';
import type { AppDB } from '../db';

export class ProcessRepository {
    constructor(private readonly database: AppDB) {}


    async getProcessEntityById(id: number) {
        return await this.database.process.where('Id').equals(id).first(async pe => {
            return pe;
        });
    }

    async getProcessEntityByCode(code: string) {
        return await this.database.process.where('Code').equals(code).first(async pe => {
            return pe;
        });
    }

    async getProcessByIdWithChildren(id: number) {
        return await this.database.process.where('Id').equals(id).first(async pe => {
            const p = mapper.map(pe, ProcessEntity, Process);
            if (pe?.MeasureId) {
                // const me =
                // const m = mapper.map(me, ProcessMeasureEntity, ProcessMeasure);
                p.ProcessMesure = await this.database.getProcessMeasureByIdWithChildren(pe.MeasureId);
            }
            if (pe?.ProcessTechniqueIds) {
                for (let i = 0; i < pe.ProcessTechniqueIds.length; i++) {
                    p.ProcessTechniqueList.push(await this.database.getProcessTechniqueByIdWithChildren(pe.ProcessTechniqueIds[i]));
                }
            }
            if (pe?.MeanOfPreventionIds) {
                for (let i = 0; i < pe.MeanOfPreventionIds.length; i++) {
                    p.EnvCollectiveMeansOfPreventionList.push(await this.database.getMeanOfPreventionById(pe.MeanOfPreventionIds[i]));
                }
            }
            if (pe?.GlobalTaskIds) {
                for (let i = 0; i < pe.GlobalTaskIds.length; i++) {
                    p.TaskList.push(await this.database.getGlobalTaskEntityById(pe.GlobalTaskIds[i]));
                }
            }
            if (pe?.ProcessCalculationId) {
                p.ProcessCalculation = await this.database.getProcessCalculationById(pe.ProcessCalculationId);
            }
            if (pe?.AreaMapId) {
                p.AreaMap = await this.database.getAreaMapById(pe.AreaMapId);
            }
            return p;
        });
    }

    async attachProcess(process: Process, interventionId: number) {
        let processId: number;
        const pe = mapper.map(process, Process, ProcessEntity);

        const ie = await this.database.getInterventionEntityById(interventionId);
        processId = await this.database.process.add(pe);
        await this.database.interventions.update(interventionId, {
            ProcessIds: ie?.ProcessIds ? [...ie.ProcessIds, processId] : [processId]
        });

        if (process.ProcessMesure) {
            await this.database.attachProcessMeasure(process.ProcessMesure, processId);
        }

        if (process.TaskList && process.TaskList.length > 0) {
            for (let i = 0; i < process.TaskList.length; i++) {
                await this.database.attachGlobalTask(process.TaskList[i], processId);
            }
        }

        if (process.ProcessTechniqueList && process.ProcessTechniqueList.length > 0) {
            for (let i = 0; i < process.ProcessTechniqueList.length; i++) {
                await this.database.attachProcessTechnique(process.ProcessTechniqueList[i], processId);
            }
        }

        if (process.ProcessCalculation) {
            await this.database.attachProcessCalculation(process.ProcessCalculation, processId);
        }

        if (process.AreaMap) {
            await this.database.attachAreaMapToProcess(process.AreaMap, processId);
        }

        if (process.EnvCollectiveMeansOfPreventionList && process.EnvCollectiveMeansOfPreventionList.length > 0) {
            for (let i = 0; i < process.EnvCollectiveMeansOfPreventionList.length; i++) {
                await this.database.attachMeanOfPrevention(process.EnvCollectiveMeansOfPreventionList[i], processId);
            }
        }
        return processId;
    }
}
